import { Box, Grid, Pagination, Stack, Typography } from "@mui/material";
import StockCard from "./stockCard";
import { getInventoryData, getStockDetail } from "./stockApi";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { useEffect } from "react";
import { useState } from "react";
import { getData } from "./stockCustomApiHandler";
import TableComponent from "./table";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { EditStockModal } from "./editStockModal";
import { ReducePop } from "./reducerlist";

const Stocks = ({ gridSize }) => {
  const [data, setData] = useState();
  const [stocks, setStocks] = useState();
  const stockPayload = {
    page: 1,
    pageSize: 100,
  };

  const [open_t, setOpen_t] = useState(false);

  const [open, setOpen] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
  });

  const handleChange = (event, value) => {
    getData({ ...stockPayload, page: value });
    setPagination({
      ...pagination,
      page: value,
    });
  };

  useEffect(() => {
    getData(
      stockPayload,
      getInventoryData,
      setStocks,
      setPagination,
      pagination
    );
  }, []);
  return (
    <Box
      px={{ xs: 0, sm: 4 }}
      pb={4}
      sx={{
        pt: "15px",
        // backgroundColor: "#E3E3FF",
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      {/* Heading */}
      {/* <Grid
        container
        sx={{
          background:
            "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
          padding: "10px",
          mt: 1,
          borderRadius: "5px",
          color: "#01008B",
          textAlign: "left",
          mb: 3,
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        <Typography variant="h6">Inventory Stock</Typography>
      </Grid> */}

      {/* Total Items & Download Icon Row */}
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ flexWrap: "wrap" }}
      >
        <Grid item xs="auto">
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              px: 2,
              py: 1,
              // mb: 1,
              backgroundColor: "#CCCCFF",
              borderRadius: "8px",
              fontWeight: 500,
            }}
          >
            <Typography
              component="span"
              sx={{ mr: 1, color: "#00008B", fontWeight: 500 }}
            >
              Total Items:&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{ fontWeight: 600, color: "#00008B" }}
            >
              {pagination.records}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs="auto">
          {gridSize && (
            <FileDownloadIcon
              sx={{
                height: "1.4375em",
                cursor: "pointer",
                ml: 2,
              }}
            />
          )}
        </Grid>
      </Grid>

      {/* Table */}
      <Grid
        container
        spacing={2}
        sx={{
          flexDirection: "column",
          mt: {xs:0, sm:2},
          maxHeight: { xs: "auto", md: "75vh" },
          overflow: "auto",
        }}
      >
        <Grid item xs={12}>
          <TableComponent
            stocks={stocks}
            setModalData={setData}
            setOpen={setOpen_t}
          />
        </Grid>
      </Grid>

      {/* <Grid container sx={{ pt: "10px" }}>
        <Grid item xs={4}>
          <Typography
            color="primary"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <strong>Total Items: &nbsp;</strong>
            <strong> {pagination.records}&nbsp;</strong>
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            // bgcolor: "red",
            display: "flex",
            justifyContent: "center",
          }}
        >
        
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid> */}
      {/* <ReducePop
        open={open_t}
        setOpen={setOpen_t}
        data={data}
        setData={setData}
        next={setOpen}
      /> */}
      <EditStockModal
        open={open_t}
        setOpen={setOpen_t}
        data={data}
        setData={setData}
        onUpdate={() => {
          getData(
            { ...stockPayload, page: pagination.page },
            getInventoryData,
            setStocks,
            setPagination,
            pagination
          );
        }}
      />
    </Box>
  );
};

export default Stocks;
